import { render, staticRenderFns } from "./groupMsgModal.vue?vue&type=template&id=a8afc66a&scoped=true"
import script from "./groupMsgModal.vue?vue&type=script&lang=js"
export * from "./groupMsgModal.vue?vue&type=script&lang=js"
import style0 from "./groupMsgModal.vue?vue&type=style&index=0&id=a8afc66a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8afc66a",
  null
  
)

export default component.exports